export default __webpack_public_path__ + "static/media/upcomming.676510e0.svg";